import { render, staticRenderFns } from "./ToggleSort.vue?vue&type=template&id=3d7d0e4b&scoped=true&lang=pug"
import script from "./ToggleSort.vue?vue&type=script&lang=ts"
export * from "./ToggleSort.vue?vue&type=script&lang=ts"
import style0 from "./ToggleSort.vue?vue&type=style&index=0&id=3d7d0e4b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7d0e4b",
  null
  
)

export default component.exports